import { station1Slice } from './station1.slice.ts';

const { updateSelectedPostSetting, resetQueryState } = station1Slice.actions;

export const updateStationOneSelectedPost = updateSelectedPostSetting;
export const resetStationOneQueryState = resetQueryState;
